import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Navigation } from 'app/core/navigation/navigation.types';
import { UrlFactory } from 'app/url.factory';
import { APP_VERSION } from 'environments/version';
import { BehaviorSubject, Observable, ReplaySubject, catchError, of, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NavigationService {
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);
    private $version: BehaviorSubject<string> = new BehaviorSubject<string>(APP_VERSION);

    public url: string;
    private _url = inject(UrlFactory);

    private _httpClient = inject(HttpClient);
    private _translocoService = inject(TranslocoService);
    private packageJsonPath = 'src/app/core/navigation';
    /**
     * Constructor
     */
    constructor() {
        this.url = this._url.asgardUrl;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    /**
     * Getter version of package.json
     */

    get version$(): Observable<string> {
        return this.$version.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data and translate it to preferred language (ES by default)
     */
    get(): Observable<Navigation> {
        // return this._api.getApi('getNavigationMenu').pipe(
        //     tap((navigation) => {
        //         this._navigation.next(navigation);
        //     }),
        //     catchError(this.handleError.bind(this))
        // );
        return this._httpClient.get<Navigation>(`${this.url}/v2/menu`).pipe(
            tap((navigation) => {
                const user = JSON.parse(window.localStorage.getItem('UserData'));
                const language = user ? user.lang : 'es';

                if (language !== 'en-US') {
                    const translatedNavigation: Navigation = {
                        ...navigation,
                        default: navigation.default.map((group) => ({
                            ...group,
                            children: group.children.map((child) => ({
                                ...child,
                                title: this._translocoService.translate(child.title),
                            })),
                        })),
                    };
                    this._navigation.next(translatedNavigation);
                } else {
                    this._navigation.next(navigation);
                }
            }),
            catchError(this.handleError.bind(this))
        );
    }

    private handleError(error) {
        this._navigation.next({
            default: [],
            compact: [],
            futuristic: [],
            horizontal: [],
        });
        return of(false);
    }
}
